export enum LockStatuses {
    NotLocked = 0,
    Locked = 1,
    ExpiredVersion = 2
}